/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/Footer.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Mon Apr 21 2025
 */

import React, { useCallback, useContext } from 'react';
import { FormSection, Button, Banner, ShippingBanner } from "@proxy/_components";
import {TranslationsContext, FormContext} from "@proxy/_contexts";
import FormErrorBlock from './FormErrorBlock';

export default function Footer({
  togglePreview
}) {

  const translations = useContext(TranslationsContext);
  
  const {
    settings,
    formData,
    handleOnSubmit,
    handleNextStep,
    validationConfig,
    currentStep,
    bulkOrder,
    conversionSurcharge,
    physicalSurcharge,
    giftCardCost,
    totalCost,
    pricingConfig,
    formErrors
  } = useContext(FormContext);

  const SubmitButton = () => {

    if (bulkOrder === true) {
      return <></>;
    }

    if (
      (settings?.global?.appearance?.form_theme === "simple" || settings?.global?.appearance?.form_theme === "crisp") ||
      (currentStep === "gift_card" && formData.properties._gcp_send_to_self === true) ||
      currentStep === "gift_message"
    ) {
      return (
        <>
          <FormErrorBlock />
          <Button
            id="gcpPurchaseFormSubmit"
            type={"submit"}
            name="gcp_submit"
            fullWidth={true}
            onClick={e => {
              handleOnSubmit(e, formData, validationConfig);
            }}
          >
            {formData.id === "Custom" ? translations.submit_button_label_checkout : translations.submit_button_label_add_to_cart}
          </Button>
        </>
      );
    }

    return (
      <>
        <FormErrorBlock />
        <Button
          id="gcpPurchaseFormSubmit"
          type={"button"}
          name="gcp_submit"
          fullWidth={true}
          onClick={(e) => {
            e.preventDefault();
            handleNextStep(formData, validationConfig);
          }}
        >
          {translations.submit_button_label_continue}
        </Button>
      </>
    );
  };

  const priceBreakdown = ((giftCardCost.value === totalCost.value) ?
    <div className="gc__flex-section gc__footer-total-section">
      <div className="gc__heading">
        {translations.gift_card_value_heading}
      </div>
      <div className="gc__heading-value">
        {totalCost.formatted}
      </div>
    </div>
  :
    <div>
      <div className="gc__flex-section gc__footer-total-section">
        <div className="gc__heading">
          {translations.gift_card_value_heading}
        </div>
        <div className="gc__heading-value">
          {giftCardCost.formatted}
        </div>
      </div>
      {(conversionSurcharge && conversionSurcharge.value) ?
        <div className="gc__flex-section gc__footer-conversion-section">
          <div className="gc__heading">
            {translations.currency_conversion_label}
          </div>
          <div className="gc__heading-value">
            {conversionSurcharge.formatted}
          </div>
        </div>
      : null}
      {(physicalSurcharge && physicalSurcharge.value) ?
        <div className="gc__flex-section gc__footer-surcharge-section">
          <div className="gc__heading">
            {translations.physical_surcharge_label}
          </div>
          <div className="gc__heading-value">
            {physicalSurcharge.formatted}
          </div>
        </div>
      : null}
    </div>
  );

  return (
    <FormSection
      additionalClasses="gc__footer-section"
    >
      <ShippingBanner />
      {priceBreakdown}
      <SubmitButton/>
      <div className="gc__hidden_desktop gc__toggle-preview-button">
        <Button
          type={"button"}
          fullWidth={true}
          onClick={() => {
            togglePreview();
          }}
        >
        {translations.open_preview}
        </Button>
      </div>
    </FormSection>
  );
};
